export default {
    'todoList': 'To-do Task',
    'toggleBatch': 'batch process',
    'toggleStandalone': 'Toggle standalone mode',
    'toreadList': 'To-read Task',
    'batchApprove': 'Batch Approve',
    'doneList': 'Finished Task',
    'readList': 'Finished Read',
    'batchWaiting': 'task loading,please wait...',
    'approveSuggestion': 'Approve Suggestion',
    'batchOk': 'I Know',
    'onlySupportMobileWrite': "signature only support mobile write",
    'batchHandle': 'Batch Handle',
    'myFlow': 'My Workflow',
    'delegationFlow': 'Workflow delegation',
    'searchFlow': 'Workflow Search',
    'instanceSearch': 'Workflow Instance Search',
    'taskSearch': 'Task Search',
    'startFlow': 'Start a workflow',
    'batchHandleFlow': 'Batch handle',
    'searchFlowPlaceholder': 'Search workflow name/originator',
    'orderNuber': 'NO.',
    'flowName': 'Workflow Name',
    'workflowName': 'Template Name',
    'curActivity': 'Current Activities',
    'stayTime': 'Stay Time',
    'originatorName': 'Originator',
    'departmentName': 'Dept. Of Originator',
    'timeout': 'Timeout',
    'noDataText': 'You have finished your work, get a rest!~',
    'searchNoDataText': 'No result',
    'loadFailedText': 'Faild to load',
    'refresh': 'Refresh',
    'circulated': 'read',
    'flowType': 'Workflow Type',
    'sourceName': 'Circulate Source',
    'reciveTime': 'Receive Time',
    'flowTemplate': 'Workflow mode',
    'startTime': 'Start Time',
    'endTime': 'End Time',
    'processing': 'Processing',
    'completed': 'Completed',
    'canceled': 'Canceled',
    'draft': 'Draft',
    'exception': 'Exception',
    'flowStatus': 'Workflow Status',
    'more': 'More',
    'add': 'Add',
    'delete': 'Delete',
    'collapse': 'Fold',
    'reset': 'Reset',
    'search': 'Search',
    'ok': 'ok',
    'cancel': 'cancel',
    'deleteTrustTips1': 'Are you sure want to delete this delegation?',
    'deleteTrustTips2': 'The delegation is invalid after deletion, the delegated party will no longer approve/initiate the process.',
    'deleteFailed': 'Delete failed, please try again',
    'deleteSuccess': 'Delete successful',
    'timeRange': '{start} to {end}',
    'plzSelect': 'Please choose one',
    'resolveTime': 'Action Time',
    'approvalNode': 'Activity Name',
    'resolveRzt': 'Action',
    'noContent': 'No result',
    'initiationTime': 'Start Time',
    'cancelTime': 'Cancel Time',
    'resolver': 'Approver',
    'curResolver': 'Current Approver',
    'usedTime': 'Used Time',
    'originatorDepartment': 'Dept. Of Originator',
    'finishedTime': 'Completed Time',
    'costTime': 'Cost Time',
    'state': 'State',
    'all': 'All',
    'noStarted': 'Unopened',
    'resolving': 'Resolving',
    'beCancled': 'Cancled',
    'searchFlowName': 'Search workflow name',
    'searchRzt': 'Search result',
    'items': 'items',
    'showAll': 'The load completed',
    'reason': 'Reason',
    'commonFlow': 'Commonly used',
    'setSevenFlows': 'Limited to 7',
    'flowItems': 'item(s)',
    'setCommon': 'Set to Commonly use',
    'cancelCommon': 'Cancel the Commonly use',
    'sevenFlowsIsMost': 'Limited set to 7',
    'timeOutAfter': 'later,it will timeout',
    'beUrged': 'Urged',
    'total': 'Total {num} items',
    'sequenceNo': 'Sequence No',
    'inputSequenceNo': 'Input sequenceNo',
    'approval': {
        'agree': 'Agree',
        'reject': 'Reject',
        'forward': 'Transfer',
        'canceled': 'Canceled',
        'undo': 'Processing'
    },
    'workflowState': {
        'draft': 'Draft',
        'processing': 'Processing',
        'completed': 'Completed',
        'canceled': 'Canceled',
        'exception': 'Exception',
    },
    'showAllTodo': 'Search completed,go and finish your work!',
    'showAllToRead': 'Search completed,go and read your notifies!',
    'showAllResult': 'Loading completed',
    'showAllSearch': 'Search completed,go and finish your work!',
    'item': 'item(s)',
    'delegation': {
        'client': 'Client',
        'consignor': 'Consignor',
        'delegateType': 'Delegate type',
        'entrustedPeriod': 'Time range',
        'operation': 'Operation',
        'workflowApproval': 'Process approval',
        'startWorkflow': 'Process initiation',
        'workflowScope': 'Workflow scope',
        'wholeProcess': 'Whole process',
        'partProcess': 'Part of the process',
        'addDelegation': 'Add entrustment',
        'editDelegation': 'Edit entrustment',
        'createDelegationTips1': 'Please complete the current entrustment information',
        'createDelegationTips2': 'Modify delegation succeeded!',
        'createDelegationTips3': 'Process delegation time overlap',
        'createDelegationTips4': 'Create delegation succeeded!',
    }
};
